import { render } from "./VueSelect.vue?vue&type=template&id=df41fe8e"
import script from "./VueSelect.vue?vue&type=script&lang=js"
export * from "./VueSelect.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__